import { ReactElement } from 'react'
import { Options, Option, ReportButton } from './subcomponents'
import { TestWrapper } from '../subcomponents'
import { H3 } from '../../../../typography'
import { colors } from '../../../../const/theme'
import { Question } from '../../../../redux/test/type'
import {
  updateAnswerForQuestion,
  reportQuestion
} from '../../../../redux/test/action'
import {
  determineQuetionContent,
  isAnswerSelected,
  isAnswerInCorrect
} from './helpers'
import Solution from './Solution'
import strings from '../../../../locale/en'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'

interface ObjectTiveTestProps {
  question: Question
  isResults?: boolean
}

const ObjectiveTest = ({
  question,
  isResults
}: ObjectTiveTestProps): ReactElement => {
  const { isReporting, reportedQuestion } = useSelector(
    (state: RootState) => state.test,
    shallowEqual
  )
  const dispatch = useDispatch()

  return (
    <TestWrapper>
      <H3
        dangerouslySetInnerHTML={{
          __html: determineQuetionContent(question)
        }}
        color={colors.black}
      />
      <Options>
        <Option
          dangerouslySetInnerHTML={{ __html: question?.optionA }}
          isSelected={isAnswerSelected(question, 'a')}
          isInCorrect={isAnswerInCorrect(question, 'a')}
          role="button"
          onClick={() => {
            !isResults &&
              dispatch(
                updateAnswerForQuestion({
                  id: question?.id,
                  selectedAnswer: 'a'
                })
              )
          }}
        />
        <Option
          dangerouslySetInnerHTML={{ __html: question?.optionB }}
          isSelected={isAnswerSelected(question, 'b')}
          isInCorrect={isAnswerInCorrect(question, 'b')}
          role="button"
          onClick={() => {
            !isResults &&
              dispatch(
                updateAnswerForQuestion({
                  id: question?.id,
                  selectedAnswer: 'b'
                })
              )
          }}
        />
        <Option
          dangerouslySetInnerHTML={{ __html: question?.optionC }}
          isSelected={isAnswerSelected(question, 'c')}
          isInCorrect={isAnswerInCorrect(question, 'c')}
          role="button"
          onClick={() => {
            !isResults &&
              dispatch(
                updateAnswerForQuestion({
                  id: question?.id,
                  selectedAnswer: 'c'
                })
              )
          }}
        />
        <Option
          dangerouslySetInnerHTML={{ __html: question?.optionD }}
          isSelected={isAnswerSelected(question, 'd')}
          isInCorrect={isAnswerInCorrect(question, 'd')}
          role="button"
          onClick={() => {
            !isResults &&
              dispatch(
                updateAnswerForQuestion({
                  id: question?.id,
                  selectedAnswer: 'd'
                })
              )
          }}
        />
      </Options>
      {isResults && <Solution question={question} />}
      {isResults && (
        <ReportButton
          variant="danger"
          disabled={
            isReporting ||
            reportedQuestion === question?.id ||
            question?.reported
          }
          onClick={() =>
            dispatch(
              reportQuestion({
                questionPaperId: question?.id,
                answer: question?.correctAnswer || '',
                reportedAnswer: question?.submittedAnswered || ''
              })
            )
          }
        >
          {strings.test.report}
        </ReportButton>
      )}
    </TestWrapper>
  )
}

export default ObjectiveTest
